import { EXPORTER_OFFER_PRODUCTS_TYPES } from "../types/exporterOfferProductsTypes";

const INITIAL_STATE = {
  createExporterOfferSuccess: null,
  productsDetailsById: null,
  exporterOfferProductsList: null,
  buyerOfferProductsList: null,
  buyerProductDetailsById: null,
  buyerLoading: false,
  loading: false,
  error: null,
};

const exporterOfferProducts = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EXPORTER_OFFER_PRODUCTS_TYPES.CREATE_EXPORTER_OFFER_PRODUCT_SUCCESS:
      return {
        ...state,
        createExporterOfferSuccess: action.payload,
      };

    case EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_PRODUCT_BY_ID_SUCCESS:
      return {
        ...state,
        productsDetailsById: action.payload,
      };
    case EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCTS_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCTS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        exporterOfferProductsList: action.payload,
        error: null,
      };
    case EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCTS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case EXPORTER_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_BUYER:
      return {
        ...state,
        buyerLoading: true,
        buyerError: null,
      };
    case EXPORTER_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_BUYER_SUCCESS:
      return {
        ...state,
        buyerLoading: false,
        buyerOfferProductsList: action.payload,
        buyerError: null,
      };
    case EXPORTER_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_BUYER_FAILURE:
      return {
        ...state,
        buyerLoading: false,
        exporterError: action.error,
      };

    case EXPORTER_OFFER_PRODUCTS_TYPES.DELETE_EXPORTER_OFFER_PRODUCT:
      return {
        ...state,
        exporterOfferProductsList: action.payload,
      };

    case EXPORTER_OFFER_PRODUCTS_TYPES.GET_BUYER_OFFER_PRODUCT_BY_ID:
      return{
        ...state,
        buyerLoading: true,
        buyerError: null,
      }
    case EXPORTER_OFFER_PRODUCTS_TYPES.GET_BUYER_OFFER_PRODUCT_BY_ID_SUCCESS:
      return{
        ...state,
         buyerLoading: false,
         buyerProductDetailsById: action.payload,
      };
    case EXPORTER_OFFER_PRODUCTS_TYPES.GET_BUYER_OFFER_PRODUCT_BY_ID_FAILURE:
      return  {
        ...state,
        buyerLoading: false,
        buyerError: action.payload,
      }      
    default:
      return state;
  }
};

export default exporterOfferProducts;
